import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact-temp',
  templateUrl: './contact-temp.component.html',
  styleUrls: ['./contact-temp.component.scss']
})
export class ContactTempComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }
}
